__turbopack_context__.v({
  "className": "noto_sans_arabic_f98647fc-module__Uz53wq__className",
});
